import { _ as y } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as A, a as m, m as I, o as T, c as f, e as d, g as p, F as w, p as D, n as L, t as S, j as g } from "./define-element-XpjsV6s1.js";
const h = {
  full: new Intl.DateTimeFormat("en-US", {
    dateStyle: "full"
  })
};
function V(r, c = "full") {
  let n = h[c] || h.full;
  if (typeof r == "string") {
    const o = r.split("-").map((u) => parseInt(u, 10));
    r = new Date(o[0], o[1] - 1, o[2]);
  }
  return n.format(r);
}
const B = { class: "offset-tabs" }, E = ["id", "aria-controls", "aria-selected", "tabindex", "onClick"], C = {
  ref: "children",
  class: "offset-tabs-content"
}, F = {
  __name: "Tabs",
  setup(r) {
    const c = A("children"), n = m(0), o = m([]), u = Math.random().toString(36).substring(2), l = I(() => {
      var e;
      return c.value == null && i.value < 0 ? [] : Array.from(((e = c.value) == null ? void 0 : e.children) || []).filter(
        (t) => t.tagName === "DIV"
      );
    });
    function b(e) {
      return `tab-${u}-${e}`;
    }
    function _(e) {
      return `tabpanel-${u}-${e}`;
    }
    function i(e, t) {
      l.value.forEach((a) => {
        a.classList.remove("active");
      }), e.classList.add("active"), n.value = t;
    }
    function k() {
      l.value.forEach((e, t) => {
        e.setAttribute("role", "tabpanel"), e.setAttribute("id", _(t)), e.setAttribute("aria-labelledby", b(t)), e.setAttribute("tabindex", "0");
      });
    }
    function $(e) {
      var s;
      const t = l.value.length;
      if (!t) return;
      let a = null;
      e.key === "ArrowRight" ? a = (n.value + 1) % t : e.key === "ArrowLeft" ? a = (n.value - 1 + t) % t : e.key === "Home" ? a = 0 : e.key === "End" && (a = t - 1), a !== null && (e.preventDefault(), i(l.value[a], a), (s = o.value[a]) == null || s.focus());
    }
    return T(() => {
      k(), n.value = l.value.findIndex((e) => e.classList.contains("active")), n.value === -1 && i(l.value[0], 0);
    }), (e, t) => (f(), d("div", B, [
      p("div", {
        class: "offset-tabs-header",
        role: "tablist",
        onKeydown: $
      }, [
        (f(!0), d(w, null, D(l.value, (a, s) => (f(), d("button", {
          key: s,
          ref_for: !0,
          ref: (v) => {
            v && (o.value[s] = v);
          },
          type: "button",
          role: "tab",
          id: b(s),
          "aria-controls": _(s),
          "aria-selected": n.value === s,
          tabindex: n.value === s ? 0 : -1,
          class: L(["offset-tab", { active: n.value === s }]),
          onClick: (v) => i(a, s)
        }, S(a.getAttribute("title")), 11, E))), 128))
      ], 32),
      p("div", C, [
        g(e.$slots, "default", {}, void 0, !0)
      ], 512)
    ]));
  }
}, j = /* @__PURE__ */ y(F, [["__scopeId", "data-v-e0b09b24"]]), R = {}, H = { class: "offset-tab" };
function K(r, c) {
  return f(), d("div", H, [
    g(r.$slots, "default", {}, void 0, !0)
  ]);
}
const z = /* @__PURE__ */ y(R, [["render", K], ["__scopeId", "data-v-f0d8cc4c"]]);
export {
  z as T,
  j as a,
  V as f
};
